const Layout = () => import(/* webpackChunkName: "base_dependent" */ '../components/Layout.vue');
const Login = () => import(/* webpackChunkName: "login" */ '../views/User/Login.vue');
const collectionlogin = () => import(/* webpackChunkName: "login" */ '../views/User/collectionlogin.vue');
const User = () => import(/* webpackChunkName: "user" */ '../views/User/User.vue');
const Resetpasswd = () => import(/* webpackChunkName: "user" */ '../views/User/Resetpasswd.vue');
const ForgetPasswd = () => import(/* webpackChunkName: "user" */ '../views/User/ForgetPasswd.vue');
const NotFound = () => import(/* webpackChunkName: "user" */ '../page404.vue');

/* 账户管理 */
const AccountInfo = () => import(/* webpackChunkName: "user" */ '../views/User/AccountInfo.vue');
const role = () => import(/* webpackChunkName: "user" */ '../views/User/role.vue');
const Menumanagement = () => import(/* webpackChunkName: "user" */ '../views/User/Menumanagement.vue');

/* 广告管理 */
const advertisingmanagement = () => import(/* webpackChunkName: "advertisingmanagement" */ '../views/Advertisingmanagement/advertisingmanagement.vue');

/**
 *@desc 提现
 */
const jzwithdrawal = () => import(/* webpackChunkName: "jzwithdrawal" */ '../views/jzwithdrawal/jzwithdrawal.vue');

/**
 *@desc 结算管理
 */
const servicecharge = () => import(/* webpackChunkName: "servicecharge" */ '../views/settlement/servicecharge.vue');
const servicechargedetail = () => import(/* webpackChunkName: "servicechargedetail" */ '../views/settlement/servicechargedetail.vue');
const settlementlist = () => import(/* webpackChunkName: "settlementlist" */ '../views/settlement/settlementlist.vue');
const settlementlistdetail = () => import(/* webpackChunkName: "settlementlistdetail" */ '../views/settlement/settlementlistdetail.vue');
const settlementorder = () => import(/* webpackChunkName: "settlementorder" */ '../views/settlement/settlementorder.vue');
const settlementorderdetail = () => import(/* webpackChunkName: "settlementorderdetail" */ '../views/settlement/settlementorderdetail.vue');
const settlerepaymentmanage = () => import(/* webpackChunkName: "settlementlist" */ '../views/settlement/settlerepaymentmanage.vue');
const settleordermanage = () => import('../views/settlement/settleordermanage.vue');
const settleorderdetail = () => import('../views/settlement/settleorderdetail.vue');

/**
 *@desc 运营管理
 */
const partner = () => import(/* webpackChunkName: "partner" */ '../views/Opreatr/partner.vue');
const product = () => import(/* webpackChunkName: "product" */ '../views/Opreatr/product.vue');
const productadd = () => import(/* webpackChunkName: "productadd" */ '../views/Opreatr/productadd.vue');
const partneradd = () => import(/* webpackChunkName: "partneradd" */ '../views/Opreatr/partneradd.vue');
/**
 *@desc 合同管理
 */
const contractlist = () => import(/* webpackChunkName: "contractlist" */ '../views/contract/contractlist.vue');
const contractmanagement = () => import(/* webpackChunkName: "contractmanagement" */ '../views/contract/contractmanagement.vue');

/**
 *@desc 交易管理
 */
const transactionlist = () => import(/* webpackChunkName: "transaction" */ '../views/transaction/transactionlist.vue');

/**
 *@desc 进件管理
 */
const loanbill = () => import(/* webpackChunkName: "loanbill" */ '../views/Lmport/loanbill.vue');
const refund = () => import(/* webpackChunkName: "offlinerefund" */ '../views/Lmport/refund.vue');
const loanbilldetail = () => import(/* webpackChunkName: "loanbilldetail" */ '../views/Lmport/loanbilldetail.vue');
const refunddetail = () => import(/* webpackChunkName: "offlinerefund" */ '../views/Lmport/refunddetail.vue');
const offlinerefund = () => import(/* webpackChunkName: "offlinerefund" */ '../views/Lmport/offlinerefund.vue');

/**
 *@desc 运营管理
 */
const generalledger = () => import(/* webpackChunkName: "loanbill" */ '../views/Repyment/generalledger.vue');
const generalledgeradd = () => import(/* webpackChunkName: "generalledgeradd" */ '../views/Repyment/generalledgeradd.vue');
const repaymentbill = () => import(/* webpackChunkName: "repaymentbill" */ '../views/Repyment/repaymentbill.vue');
const repaymentbilladd = () => import(/* webpackChunkName: "repaymentbilladd" */ '../views/Repyment/repaymentbilladd.vue');
const repaymentorder = () => import(/* webpackChunkName: "repaymentorder" */ '../views/Repyment/repaymentorder.vue');
const generalledgerdetail = () => import(/* webpackChunkName: "generalledgerdetail" */ '../views/Repyment/generalledgerdetail.vue');
const repaymentbilldetail = () => import(/* webpackChunkName: "repaymentbilldetail" */ '../views/Repyment/repaymentbilldetail.vue');
const repaymentorderdetail = () => import(/* webpackChunkName: "repaymentorderdetail" */ '../views/Repyment/repaymentorderdetail.vue');
const repaymentmanage = () => import(/* webpackChunkName: "repaymentmanage" */ '../views/Repyment/repaymentmanage.vue');
const repaymentmanagedetail = () => import(/* webpackChunkName: "repaymentmanagedetail" */ '../views/Repyment/repaymentmanagedetail.vue');
const repaymentdetail = () => import(/* webpackChunkName: "repaymentdetail" */ '../views/Repyment/repaymentdetail.vue');
const repaymentanalyze = () => import('../views/Repyment/repaymentanalyze.vue');
const repaymentdayanalyze = () => import('../views/Repyment/repaymentdayanalyze.vue');
const repaymentpaydetail = () => import('../views/Repyment/repaymentpaydetail.vue');
const mdmdevicemanage = () => import('../views/Repyment/mdmdevicemanage.vue');
const mdmdevicedetail = () => import('../views/Repyment/mdmdevicedetail.vue');
const repaymentothermanage = () => import('../views/Repyment/repaymentothermanage.vue');
const repaymentcheckhx = () => import('../views/Repyment/repaymentcheckhx.vue');
const hxoverdueanalyze = () => import('../views/Repyment/hxOverdueAnalyze.vue');
const shopoverdueanalyze = () => import('../views/Repyment/shopOverdueAnalyze.vue');
const deviceoverdueanalyze = () => import('../views/Repyment/deviceOverdueAnalyze.vue');
const periodoverdueanalyze = () => import('../views/Repyment/periodOverdueAnalyze.vue');
const cityoverdueanalyze = () => import('../views/Repyment/cityOverdueAnalyze.vue');

/**
 * 资方贷后管理
 */
const investorrepayment = () => import('../views/Investors/investorrepayment.vue');

/**
 *@desc 财务管理
 */

const downloadtask = () => import(/* webpackChunkName: "channelreconciliation" */ '../views/Finance/downloadtask.vue');
const channelreconciliation = () => import(/* webpackChunkName: "channelreconciliation" */ '../views/Finance/channelreconciliation.vue');
const channelreconciliationdetails = () => import(/* webpackChunkName: "channelreconciliationdetails" */ '../views/Finance/channelreconciliationdetails.vue');
const internalreconciliation = () => import(/* webpackChunkName: "internalreconciliation" */ '../views/Finance/internalreconciliation.vue');
const internalreconciliationdetails = () => import(/* webpackChunkName: "internalreconciliationdetails" */ '../views/Finance/internalreconciliationdetails.vue');
const Statistics = () => import(/* webpackChunkName: "Statistics" */ '../views/Finance/Statistics.vue');

/**
 *@desc 机器人管理
 */

const robotrules = () => import(/* webpackChunkName: "robotrules" */ '../views/robot/robotrules.vue');
const robottask = () => import(/* webpackChunkName: "robottask" */ '../views/robot/robottask.vue');
const casedetails = () => import(/* webpackChunkName: "casedetails" */ '../views/robot/casedetails.vue');

/**
 *@desc 委外管理
 */

const Outsourcinglist = () => import(/* webpackChunkName: "Outsourcinglist" */ '../views/Outsourcing/Outsourcinglist.vue');
const Outsourcinglistnew = () => import(/* webpackChunkName: "Outsourcinglistnew" */ '../views/Outsourcing/Outsourcinglistnew.vue');
const Outsourcinglistdetail = () => import(/* webpackChunkName: "Outsourcinglistdetail" */ '../views/Outsourcing/Outsourcinglistdetail.vue');
const Outsourcingsettlement = () => import(/* webpackChunkName: "Outsourcingsettlement" */ '../views/Outsourcing/Outsourcingsettlement.vue');
const settlement = () => import(/* webpackChunkName: "settlement" */ '../views/Outsourcing/settlement.vue');

/**
 *@desc 信息配置
 */
const Settlementconfiguration = () => import(/* webpackChunkName: "Settlementconfiguration" */ '../views/Toconfigure/Settlementconfiguration.vue');

/**
 *@desc 统计
 */
const Collectionreport = () => import(/* webpackChunkName: "Collectionreport" */ '../views/Statistics/Collectionreport.vue');
/**
 *@desc 催收首页
 */
const homepage = () => import(/* webpackChunkName: "homepage" */ '../views/Homepage/homepage.vue');

/**
 *@desc 省包商管理
 */

const toconfigure = () => import(/* webpackChunkName: "toconfigure" */ '../views/Merchant/toconfigure.vue');
const contractor = () => import(/* webpackChunkName: "contractor" */ '../views/Merchant/contractor.vue');
const contractorservicecharge = () => import(/* webpackChunkName: "contractorservicecharge" */ '../views/Merchant/contractorservicecharge.vue');
/**
 *@desc 配置
 */

const productmanagement = () => import(/* webpackChunkName: "productmanagement" */ '../views/Configurationtotal/productmanagement.vue');
const loanconfiguration = () => import('../views/Configurationtotal/loanconfiguration');
const typepoolmanagement = () => import('../views/Configurationtotal/typepoolmanagement.vue');
const keypoolmanagement = () => import('../views/Configurationtotal/keypoolmanagement.vue');
const apppoolmanagement = () => import('../views/Configurationtotal/apppoolmanagement.vue');
const phonepoolmanagement = () => import('../views/Configurationtotal/phonepoolmanagement.vue');
const hexiphonepoolmanagement = () => import('../views/Configurationtotal/hexiphonepoolmanagement.vue');
const commissionconfiguration = () => import('../views/Configurationtotal/commissionconfiguration.vue')
const riskrulemanagement = () => import('../views/Configurationtotal/riskrulemanagement.vue');
const wechattemplatemanage = () => import('../views/Configurationtotal/wechattemplatemanage.vue')
/**
 *@desc 订单管理
 */
const orderList = () => import(/* webpackChunkName: "orderList" */ '../views/Ordermanagement/orderList.vue');
const orderListdetail = () => import(/* webpackChunkName: "orderListdetail" */ '../views/Ordermanagement/orderListdetail.vue');
const refundList = () => import(/* webpackChunkName: "refundList" */ '../views/Ordermanagement/refundList.vue');
const refundListdetail = () => import(/* webpackChunkName: "refundListdetail" */ '../views/Ordermanagement/refundListdetail.vue');

/**
 *@desc 商户管理
 */

const merchantinfo = () => import(/* webpackChunkName: "merchantinfo" */ '../views/Merchant/merchantinfo.vue');
const addmerchantinfo = () => import(/* webpackChunkName: "merchantinfo" */ '../views/Merchant/addmerchantinfo.vue');
const merchantinfodetail = () => import(/* webpackChunkName: "merchantinfodetail" */ '../views/Merchant/merchantinfodetail.vue');
const hallinfo = () => import(/* webpackChunkName: "hallinfo" */ '../views/Merchant/hallinfo.vue');
const addhallinfo = () => import(/* webpackChunkName: "merchantinfo" */ '../views/Merchant/addhallinfo.vue');
const hallinfodetail = () => import(/* webpackChunkName: "hallinfodetail" */ '../views/Merchant/hallinfodetail.vue');
const sellerinfo = () => import(/* webpackChunkName: "sellerinfo" */ '../views/Merchant/sellerinfo.vue');
const sellerinfodetail = () => import(/* webpackChunkName: "sellerinfodetail" */ '../views/Merchant/sellerinfodetail.vue');
const traderinfo = () => import(/* webpackChunkName: "traderinfo" */ '../views/Merchant/traderinfo.vue');
const contractordetail = () => import(/* webpackChunkName: "contractordetail" */ '../views/Merchant/contractordetail.vue');
/**
 *@desc 审核
 */

const merchanttoexamine = () => import(/* webpackChunkName: "merchanttoexamine" */ '../views/Toexamine/merchanttoexamine.vue');
const halltoexamine = () => import(/* webpackChunkName: "halltoexamine" */ '../views/Toexamine/halltoexamine.vue');
const halltoexaminedetail = () => import(/* webpackChunkName: "halltoexaminedetail" */ '../views/Toexamine/halltoexaminedetail.vue');
const finaljudgment = () => import(/* webpackChunkName: "finaljudgment" */ '../views/Toexamine/finaljudgment.vue');
const finaljudgmentdetail = () => import(/* webpackChunkName: "finaljudgmentdetail" */ '../views/Toexamine/finaljudgmentdetail.vue');
const biopsyreview = () => import(/* webpackChunkName: "finaljudgment" */ '../views/Toexamine/biopsyreview.vue');
const biopsyreviewdetail = () => import(/* webpackChunkName: "biopsyreviewdetail" */ '../views/Toexamine/biopsyreviewdetail.vue');
const proveanalyze = () => import('../views/Toexamine/proveanalyze.vue');
const phonecallanalyze = () => import('../views/Toexamine/phonecallanalyze.vue');
const smsanalyze = () => import('../views/Toexamine/smsanalyze.vue');
const phonebookanalyze = () => import('../views/Toexamine/phonebookanalyze.vue');

//
const riderbrandList = () => import(/* webpackChunkName: "riderbrandList" */ '../views/Brandmodel/riderbrandList.vue');
const ridermodelList = () => import(/* webpackChunkName: "ridermodelList" */ '../views/Brandmodel/ridermodelList.vue');

// 用户管理
const usermanagement = () => import(/* webpackChunkName: "usermanagement" */ '../views/User/usermanagement.vue');
const usermanagementdetail = () => import(/* webpackChunkName: "usermanagementdetail" */ '../views/User/usermanagementdetail.vue');
const blackusermanagement = () => import('../views/User/blackusermanagement.vue');
const blackelementmanagement = () => import('../views/User/blackelementmanagement.vue');
const estimatemanagement = () => import('../views/User/estimatemanagement.vue');
const estimatemanagementdetail = () => import('../views/User/estimatemanagementdetail.vue');

const userAuthList = () => import('../views/Toexamine/userAuthList.vue');
const userAuthDetail = () => import('../views/Toexamine/userAuthDetail.vue');

// 回收管理
const recycleOrderManage = () => import('../views/recycle/recycleOrderManage.vue');
const recycleOrderDetail = () => import('../views/recycle/recycleOrderDetail.vue');
const introduction = () => import('../views/recycle/introduction.vue');
const recycleSettlerepaymentmanage = () => import('../views/recycle/recycleSettleRepaymentManage.vue');
const recycleSettleOrderManage = () => import('../views/recycle/recycleSettleOrderManage.vue');
const recyclesettleorderdetail = () => import('../views/recycle/recyclesettleorderdetail.vue');
const recycletransactionlist = () => import('../views/recycle/recycletransactionlist.vue')

const components = {
  Layout,
  advertisingmanagement,
  Login,
  User,
  AccountInfo,
  role,
  Resetpasswd,
  ForgetPasswd,
  jzwithdrawal,
  Menumanagement,
  robotrules,
  robottask,
  casedetails,
  servicecharge,
  settlementlist,
  servicechargedetail,
  settlementlistdetail,
  settlerepaymentmanage,
  settleordermanage,
  settleorderdetail,
  partner,
  product,
  productadd,
  partneradd,
  contractlist,
  transactionlist,
  loanbill,
  refund,
  loanbilldetail,
  refunddetail,
  offlinerefund,
  generalledger,
  generalledgeradd,
  repaymentbill,
  repaymentbilladd,
  repaymentorder,
  generalledgerdetail,
  repaymentbilldetail,
  repaymentorderdetail,
  repaymentmanage,
  repaymentmanagedetail,
  repaymentdetail,
  repaymentothermanage,
  repaymentanalyze,
  repaymentdayanalyze,
  repaymentpaydetail,
  repaymentcheckhx,
  hxoverdueanalyze,
  shopoverdueanalyze,
  deviceoverdueanalyze,
  periodoverdueanalyze,
  cityoverdueanalyze,
  investorrepayment,
  mdmdevicemanage,
  mdmdevicedetail,
  downloadtask,
  channelreconciliation,
  channelreconciliationdetails,
  internalreconciliation,
  internalreconciliationdetails,
  Outsourcinglist,
  Outsourcinglistdetail,
  collectionlogin,
  Outsourcinglistnew,
  Outsourcingsettlement,
  Settlementconfiguration,
  Collectionreport,
  settlement,
  homepage,
  Statistics,
  toconfigure,
  loanconfiguration,
  // // toconfiguredetail,
  // // toconfigureadd,
  contractordetail,
  // contractor,
  // contractorservicecharge,
  productmanagement,
  typepoolmanagement,
  keypoolmanagement,
  apppoolmanagement,
  phonepoolmanagement,
  hexiphonepoolmanagement,
  commissionconfiguration,
  wechattemplatemanage,
  riskrulemanagement,
  orderList,
  orderListdetail,
  refundList,
  refundListdetail,

  merchantinfo,
  addmerchantinfo,
  merchantinfodetail,
  hallinfo,
  addhallinfo,
  hallinfodetail,
  sellerinfo,
  sellerinfodetail,
  contractorservicecharge,
  contractor,
  traderinfo,
  merchanttoexamine,
  halltoexamine,
  halltoexaminedetail,
  finaljudgment,
  finaljudgmentdetail,
  riderbrandList,
  ridermodelList,
  settlementorder,
  settlementorderdetail,
  contractmanagement,
  biopsyreview,
  biopsyreviewdetail,
  usermanagement,
  usermanagementdetail,
  blackusermanagement,
  blackelementmanagement,
  estimatemanagement,
  estimatemanagementdetail,
  userAuthList,
  userAuthDetail,
  proveanalyze,
  phonecallanalyze,
  phonebookanalyze,
  smsanalyze,
  recycleOrderManage,
  recycleOrderDetail,
  introduction,
  recycleSettlerepaymentmanage,
  recycleSettleOrderManage,
  recyclesettleorderdetail,
  recycletransactionlist,
  NotFound
};
module.exports.default = module.exports = components;
